import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const machineApi = createApi({
  reducerPath: 'machineApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['Machine'],
  endpoints: (builder) => ({
    getMachines: builder.query<unknown[], void>({
      query: () => 'machines',
      providesTags: ['Machine'],
    }),
    getMachineFloor: builder.query<unknown[], void>({
      query: () => 'machines/floor',
      providesTags: ['Machine'],
    }),
    getAvailableMachines: builder.query<unknown[], string | void>({
      query: (type) => ({ url: 'machines/availability', params: type ? { type } : {} }),
      providesTags: ['Machine'],
    }),
    getMachine: builder.query<unknown, string>({
      query: (id) => `machines/${id}`,
      providesTags: ['Machine'],
    }),
    assignJob: builder.mutation<unknown, { machineId: string; data: Record<string, unknown> }>({
      query: ({ machineId, data }) => ({
        url: `machines/${machineId}/assign-job`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Machine'],
    }),
    releaseMachine: builder.mutation<unknown, string>({
      query: (id) => ({ url: `machines/${id}/release`, method: 'POST' }),
      invalidatesTags: ['Machine'],
    }),
  }),
});

export const {
  useGetMachinesQuery,
  useGetMachineFloorQuery,
  useGetAvailableMachinesQuery,
  useGetMachineQuery,
  useAssignJobMutation,
  useReleaseMachineMutation,
} = machineApi;
